import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '../services/api/auth.service';
import { FeathersService } from '../services/api/feathers.service';
import { navigateToLoginWithNext } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private feathers: FeathersService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const auth = this.auth.isUserAuthenticated;
    if (
      !auth &&
      this.feathers.existingToken &&
      this.feathers.existingRefreshToken
    ) {
      return this.feathers.reAuthenticate.pipe(
        catchError(() => of(false)),
        map((res) => !!res)
      );
    } else {
      if (!auth) {
        navigateToLoginWithNext(this.router, this.route, state.url);
      }
      return of(auth);
    }
  }
}
